export enum ServiceStatus {
  ANALYZED = 'analyzed',
  PENDING = 'pending',
  CANCELLED = 'cancelled'
}
